// Reference: https://github.com/magento/pwa-studio/pull/90/files
export function getUrlKey(deepLink: string): string {
  const url = new URL(deepLink);
  const basename = url.pathname.slice(url.pathname.lastIndexOf("/") + 1);
  return basename.replace(/\.html$/, "");
}
